import { useEffect, useState } from "react";
import { getContent } from "../lib/api";
import { PebbleMark } from "../components/Logo";
import { SiteHeader } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { Stats, Marquee, Gallery, Amenities } from "../components/landing/Showcase";
import { Sleeping, Location } from "../components/landing/Stay";
import { BookingBand, Weddings, Rules, Faq, Contact, Footer } from "../components/landing/BookClose";
import { EventInquiry } from "../components/landing/EventInquiry";
import { OptInCard } from "../components/landing/OptInCard";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    getContent().then(setContent).catch(() => setError("Couldn't load — check your connection and refresh."));
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center" data-testid="landing-error">
        <p className="text-soft">{error}</p>
      </div>
    );
  }
  if (!content) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center" data-testid="landing-loading">
        <div className="animate-pulse flex flex-col items-center gap-3">
          <PebbleMark size={48} />
          <p className="text-soft font-serif italic">Opening the gate…</p>
        </div>
      </div>
    );
  }

  const { property, photos, landing } = content;
  const weddings = landing.weddings;

  return (
    <div className="bg-cream min-h-screen" data-testid="landing-page">
      <SiteHeader property={property} />
      <Hero hero={landing.hero} property={property} />
      <Stats stats={landing.stats} />
      <Marquee items={landing.marquee} />
      <Gallery photos={photos.gallery} credit={photos.credit} />
      <Amenities amenities={landing.amenities} />
      <Sleeping sleeping={landing.sleeping} property={property} photo={photos.gallery[5]?.url || photos.cover} />
      <Location location={landing.location} photo={photos.gallery[1]?.url || photos.cover} />
      <BookingBand landing={landing} property={property} />
      <Weddings weddings={weddings} property={property} />
      <EventInquiry property={property} />
      <Rules rules={landing.rules} />
      <Faq faqs={landing.faqs} />
      <Contact property={property} />
      <OptInCard />
      <Footer property={property} />
    </div>
  );
}
